/**
 * This function is used to localize the article URL in the article body.
 * @param body The article body
 * @param locale The locale to localize the URL to
 * @returns
 */
export const localizeArticleUrl = (body: string, locale: string) => {
  // The regex pattern to match the URL
  const regexPattern =
    /<a href="https?:\/\/(?:www\.)?(faire|faire-stage).com\/support\/articles\/.*" target="_blank" rel="noopener noreferrer">/g;

  // Replace the matching string with the modified URL
  const modifiedString = body.replace(regexPattern, (match) => {
    const matchedUrls = [...match.matchAll(/href="([^"]*)"/g)];
    for (const matchedUrl of matchedUrls) {
      const url = matchedUrl[1];
      if (!url) {
        continue;
      }

      const modifiedUrl = url.replace("/support/", `/${locale}/support/`);
      match = match.replace(url, modifiedUrl);
    }
    return match;
  });
  return modifiedString;
};
